import EventMarker from "../EventMarker";
import React from "react";
import {Grid} from "@material-ui/core";
import {DateFormat} from "../../../../../helpers/DateFormat";
import {AccessibilityNew} from "@material-ui/icons";
import purge from "../Purge"

const LATITUDE = 0, LONGITUDE = 1, SPEED = 2,
    COURSE = 3, ACCURACY = 4, TIMESTAMP = 5;

function getMarkerSvg(angle){
    return `
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 35 35">
            <g transform="rotate(${angle} 17.5 17.5)">
                <g transform="translate(-4.000000, -4.000000)">
                    <path d="M21.5,7.5 C29.2175,7.5 35.5,13.7825 35.5,21.5 C35.5,29.2175 29.2175,35.5 21.5,35.5 C13.7825,35.5 7.5,29.2175 7.5,21.5 C7.5,13.7825 13.7825,7.5 21.5,7.5 M21.5,4 C11.84,4 4,11.84 4,21.5 C4,31.16 11.84,39 21.5,39 C31.16,39 39,31.16 39,21.5 C39,11.84 31.16,4 21.5,4 L21.5,4 Z M23.25,21.5 L23.25,14.5 L19.75,14.5 L19.75,21.5 L14.5,21.5 L21.5,28.5 L28.5,21.5 L23.25,21.5 Z" fill="#fff"/>
                </g>
            </g>
        </svg>
    `
}

function property(key, value){
    return (
        <React.Fragment key={key}>
            <Grid item xs={6}>
                <b>{key}</b>
            </Grid>
            <Grid item xs={6}>
                {value}
            </Grid>
        </React.Fragment>
    )
}

function eventType(event, classes){
    return (
        <React.Fragment key="Type">
            <Grid item xs={6}>
                <b className={classes.event}><AccessibilityNew/> GPS Location</b>
            </Grid>
            <Grid item xs={6}>
                {(new DateFormat(event[TIMESTAMP])).datetime()}
            </Grid>
        </React.Fragment>
    )
}

function getPosition(row) {
    return EventMarker.latLng(row[LATITUDE], row[LONGITUDE])
}

export default {
    type: "gps",
    label: "GPS",
    getPosition: getPosition,
    getMarkers: (row) => {
        return [new EventMarker(
            getPosition(row),
            getMarkerSvg(row[COURSE]),
            row[ACCURACY]
        )]
    },
    timestampOffset: TIMESTAMP,
    getProperties: (row, type, classes) => {
        const speed = row[SPEED]
        if (speed !== null){
            return [
                eventType(row, classes),
                property("Speed", purge(row[SPEED], 'kph'))
            ]
        }
        return [eventType(row, classes)]
    }
}